<template lang="pug">
  .menu(:class="{ 'dark' : $route.meta.menuColor, 'open' : open, 'close' : !open }" ref="menu")
    Hamburger(:open="open" :dark="$route.meta.menuColor === 'dark' || open" @click="toggle")
    #mobile-logo(@click.prevent="goHome()")
      img(:src="require('@/assets/images/kex-logo-mobile.svg')")
    div(@click.prevent="goHome()")
      MenuLogo(:open="open" :comingSoon="comingSoon" :color="$route.meta.menuColor")
    BookingButton(:open="open" :comingSoon="comingSoon" :color="$route.meta.menuColor" :closedButton="closedButton" :bookingButton="bookingButton")
    .coming-soon(v-if="site === 'prelaunch'")
      .disable-nav
      .coming-soon-cta
        span Full Site Launching Winter 2019
    .navigation
      .main-links
        router-link(
          class="nav-link"
          v-for="link in mainNavigation"
          :to="link.slug"
          :ref="link.slug"
          @click.native="toggle()"
          :key="link.length"
          @mouseover.native="hover(link.navBgColor)"
          @mouseleave.native="resetBg"
        ) {{ link.title }}
      .secondary-links
        router-link(
          class="nav-link"
          v-for="link in secondaryNavigation"
          :to="link.slug"
          @click.native="toggle(open)"
          :key="link.length"
        ) {{ link.title }}
      .info
        .email
          label(ref="label" v-if="comingSoon") Get Launch Updates
          label(ref="label" v-else) Don't be a stranger
          label.visuallyhidden(for="menu-email") Email Address
          input#menu-email(name="menu-email" placeholder="Email Address" v-model="emailAddress" v-on:keyup.enter="sendEmail")
          button.submit(@click.prevent="sendEmail")
            <svg xmlns="http://www.w3.org/2000/svg" width="54.949" height="32.425" viewBox="0 0 54.949 32.425">
              <path id="Down_Arrow" data-name="Down Arrow" d="M-10554.586-761.6l25,25,25-25" transform="translate(10557.061 764.076)" fill="none" stroke="#2a2423" stroke-width="7"/>
            </svg>
            span.visuallyhidden Submit email
        .contact-info
          .social
            a(href="https://www.instagram.com/kexportland/" target="_blank")
              img(src="../assets/images/instagram.svg" alt="KEX Instagram")
            a(href="https://www.facebook.com/KEX-Portland-301586250618439/" target="_blank")
              img(src="../assets/images/facebook.svg" alt="KEX Facebook")
          .address
            a(target="_blank" :href="`tel:${contact.phone}`" v-html="contact.phone")
          .address
            a(target="_blank" :href="contact.addressUrl" v-html="contact.address")
            a(target="_blank" :href="contact.addressUrl" v-html="contact.cityState")
</template>

<script>
import debug from 'debug'
import { mapActions, mapState } from 'vuex'

import axios from 'axios'

import MenuLogo from '@/components/MenuLogo'
import BookingButton from '@/components/BookingButton'
import Hamburger from '@/components/elements/Hamburger'

import { EmailRule } from '@/utilities/Rules'

let log = debug('component:Menu')

export default {
  name: 'my-menu',
  props: {
    site: String,
    color: String,
    close: Boolean,
  },
  data () {
    return {
      open: false,
      mainNavigation: [],
      secondaryNavigation: [],
      contact: [],
      bookingButton: {},
      closedButton: '',
      emailAddress: '',
      comingSoon: this.site === 'prelaunch' || this.$route.name === 'ComingSoon',
    }
  },
  mounted () {
    log('Mounted')
    this.$refs.menu.classList.remove('close')
    this.setNavigation()
    this.checkPageScroll()
    window.addEventListener('resize', this.backgroundColor)
    window.addEventListener('resize', this.checkPageScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.backgroundColor)
    window.removeEventListener('resize', this.checkPageScroll)
  },
  watch: {
    close () {
      if (this.close) {
        this.open = false
      }
    },
    open () {
      this.resetBg()
      this.checkPageScroll()
    },
    menuItems (newData) {
      this.mainNavigation = newData.entries
      this.secondaryNavigation = newData.subEntries
      this.contact = newData.contact
      this.bookingButton = newData.bookingButton
    },
  },
  computed: {
    ...mapState('menu', ['menuState', 'light', 'dark', 'menuItems']),
  },
  methods: {
    ...mapActions('menu', ['menuToggle', 'bookingToggle', 'setNavigation']),
    hover (color) {
      if (window.innerWidth > 768) {
        this.$refs.menu.style.background = color
      }
    },
    backgroundColor () {
      if (window.innerWidth <= 768 || (window.innerWidth > 768 && this.open)) {
        this.$refs.menu.style.background = '#f6eeeb'
      } else {
        this.$refs.menu.style.background = 'transparent'
      }
    },
    // Toggle the ability for body to scroll
    checkPageScroll () {
      const el = document.body
      let vh = window.innerHeight * 0.01
      el.style.setProperty('--vh', `${vh}px`)

      if (this.open) {
        el.classList.add('no-scroll')
      } else {
        el.classList.remove('no-scroll')
      }
    },
    resetBg () {
      if (window.innerWidth > 768) {
        this.open ? this.$refs.menu.style.background = '#f6eeeb' : this.$refs.menu.style.background = 'transparent'
      }
      this.hovering = false
    },
    toggle () {
      this.resetBg()
      this.open = !this.open
      if (!this.open) {
        this.emailAddress = ''
      }
    },
    sendEmail (event) {
      event.preventDefault()
      log(this.emailAddress, EmailRule.test(this.emailAddress))

      if (EmailRule.test(this.emailAddress)) {
        axios({
          method: 'GET',
          url: `/api/subscribe.json?email=` + this.emailAddress,
        })
          .then(resp => {
            log(resp)
            this.emailAddress = ''

            if (resp.data.status === 400) {
              this.$refs.label.innerHTML = 'You\'re already subscribed!'
            } else {
              this.$refs.label.innerHTML = 'We\'ll be in touch'
            }
          })
          .catch(err => {
            log('Mailchimp', err, err.response)
            this.$refs.label.innerHTML = err
          })
      } else {
        this.$refs.label.innerHTML = 'Please enter a valid email'
      }
    },
    goHome () {
      this.$router.push({ path: '/' })
      this.open = false
    },
  },
  components: {
    Hamburger,
    MenuLogo,
    BookingButton,
  },
}
</script>

<style scoped lang="scss">
$animationTime: 448ms;

.menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  min-height: 55px;
  background: transparent;
  z-index: 100;
  text-transform: uppercase;
  pointer-events: all;
  transform: translateX(-100%) translateX(117px);
  transition: transform $animationTime ease-in, top $animationTime ease-in, background $animationTime/4 $animationTime ease-in, height $animationTime ease-in;

  @media #{$mobile} {
    background: $cream;
    transform: none;
    top: calc(-100% + 57px);
    top: calc(-1 * calc(var(--vh, 1vh) * 100) + 57px);
  }

  &.dark {
    #book-now {
      color: $cream;
      background: $black;

      @media #{$mobile} {
        color: $violent-sunset;
        background: transparent;
        bottom: auto;
      }
    }
  }

  &.open {
    transform: translateX(0%);
    transition: transform $animationTime ease-in, top $animationTime ease-in, background $animationTime/2 0ms ease-in;
    animation: menuOpen 0.5s ease;
    transform: translate3d(0, 0%, 0);

    @media #{$mobile} {
      transform: none;
      top: 0;
    }

    #book-now {
      color: $cream;
      background: $black;
      z-index: 10000;

      @media #{$mobile} {
        color: $violent-sunset;
        background: transparent;
        bottom: auto;
      }

      &.boooking {
        animation: animateButtonMenuOpen 1.8s ease;
      }

      &.closedButton {
        animation: closeButtonMenuOpen 1s ease;
      }

      &:hover {
        cursor: pointer;
        text-decoration: none;
        background: $violent-sunset;
        transition: all 0.2s ease;
      }
    }
  }
}

@keyframes animateButtonMenuOpen {
  0% {
    background: $violent-sunset;
  }

  90% {
    transform: scale(70);
    background: $violent-sunset;
  }

  100% {
    background: $cream;
  }
}

@keyframes closeButtonMenuOpen {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(70);
  }

  90% {
    background: $violent-sunset;
  }

  99% {
    transform: scale(1);
  }
}

#mobile-logo {
  position: fixed;
  top: 17px;
  left: 50%;
  transform: translateX(-50%);
  display: none;

  @media #{$mobile} {
    display: block;
  }
}

.coming-soon {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(85vw - 25%);
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  @media #{$mobile} {
    width: 100vw;
    height: 60%;
    margin-top: 9vh;
  }

  .disable-nav {
    position: absolute;
    background: $cream;
    opacity: 0.8;
    width: 100%;
    height: 100%;
  }

  .coming-soon-cta {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 23.7125rem;
    height: 23.7125rem;
    background: $violent-sunset;
    border-radius: 50%;
    transform: translate(-50%, -50%);

    @media #{$mobile} {
      width: 258px;
      height: 258px;
    }

    span {
      color: $cream;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 1.75rem;;
      width: 60%;
      line-height: 2;

      @media #{$mobile} {
        font-size: 1.25rem;
      }
    }
  }
}

.navigation {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  padding: 70px 90px;
  min-height: 550px;
  margin-left: env(safe-area-inset-left);

  @media (max-width: 1150px) {
    display: block;
    padding: 6% 20px 0;
    width: 100vw;
    min-height: auto;
    flex-direction: column;
    overflow: auto;
  }

  @media #{$mobile} {
    padding: 0 20px;
    max-height: calc(100vh - 57px);
    max-height: calc((var(--vh, 1vh) * 100) - 57px);
    overflow: auto;
    transform: translateY(0px);
    transition: transform $animationTime ease-in;
  }

  .main-links, .secondary-links {
    display: flex;
    flex-direction: column;

    .nav-link {
      color: $black;
      text-decoration: none;
    }
  }

  .main-links {
    width: 48%;
    height: 100%;
    justify-content: flex-end;
    margin-bottom: -15px;
    max-height: 610px;

    @media (max-width: 1150px) {
      width: 100%;
      height: auto;
      justify-content: flex-start;
    }

    @media #{$mobile} {
      margin-bottom: 10px;
    }

    .nav-link {
      font-size: 4.5rem;
      font-family: 'Local Gothic';
      line-height: 1;
      transition: all 0.3s ease;
      margin: 2% 0;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        color: $cream;

        @media #{$mobile} {
          color: $black;
        }
      }
      @media (max-width: 1150px) {
        font-size: 4rem;
      }
      @media #{$mobile} {
        font-size: 2.5rem;
        margin: 0;
      }
    }
  }

  .secondary-links {
    width: 18%;
    margin-bottom: -0.25px;

    @media (max-width: 1150px) {
      width: 100%;
      margin: 30px 0;
    }
  }

  .secondary-links {

    .nav-link {
      font-size: 1.8em;
      font-family: 'Martha Black';
      transition: all 0.2s linear;
      margin-bottom: 5px;

      &:last-child {
        padding-bottom: 0;
        margin-bottom: -2px;
      }

      @media (max-width: 1150px) {
        font-size: 1.5em;
      }

      @media #{$mobile} {
        font-size: 1.3em;
        margin-bottom: 0;
      }

      &:hover {
        color: $violent-sunset;
      }
    }
  }
}

.info {
  width: 20%;
  margin-right: 10%;
  margin-bottom: -1.5px;

  @media (max-width: 1150px) {
    width: 100%;
    margin: 0;
  }

  @media #{$mobile} {
    padding-bottom: 15px;
  }
}

.submit {
  width: 30px;
}

.email {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;

  @media (max-width: 1150px) {
    width: 40%;
  }

  @media #{$mobile} {
    width: 75%;
  }

  label {
    font-family: 'Martha Regular';
    text-transform: uppercase;
    font-size: 1em;
    margin-bottom: -5px;

    @media #{$mobile} {
      font-size: 0.8em;
      margin-bottom: -10px;
    }
  }

  input {
    border: none;
    background: transparent;
    border-bottom: 2px solid $black;
    width: 100%;
    margin-top: 20px;
    font-size: 20px;
    padding-bottom: 5px;
    border-radius: 0;

    @media #{$mobile} {
      width: 100%;
      padding: 0;
      margin-top: 20px;
    }

    &::placeholder {
      color: $black;
      opacity: 0.35;
      font-family: 'Martha Regular';
      font-size: 0.9em;

      @media #{$mobile} {
        font-size: 0.7em;
        padding-top: 8px;
        margin: 0;
      }
    }

    &:focus {
      outline: none;
    }
  }

  button {
    background: transparent;
    border: none;
    transform: rotate(-90deg);
    position: absolute;
    right: -14px;
    width: 35px;
    bottom: 0px;

    @media #{$mobile} {
      right: 2px;
      width: 32px;
      height: 17px;
      top: 28px;
    }

    @supports (-webkit-overflow-scrolling: touch) {
      bottom: -90px;
      top: 26px;
      width: 40px;
      right: -10px;
      height: 24px;
    }

    &:hover {
      cursor: pointer;
      animation: bounce 3s infinite forwards;
    }

    svg {
      width: 100%;
    }
  }
}

@keyframes bounce {
  0% {
    transform: translate(0px, 0px) rotate(-90deg);
  }

  25% {
    transform: translate(2px, 0px) rotate(-90deg);
  }

  50% {
    transform: translate(0px, 0px) rotate(-90deg);
  }

  75% {
    transform: translate(2px, 0px) rotate(-90deg);
  }

  100% {
    transform: translate(0px, 0px) rotate(-90deg);
  }
}

.contact-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media #{$mobile} {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-end;
  }

  .address {
    display: flex;
    flex-direction: column;

    &:hover {
      a {
        text-decoration: underline;
      }
    }

    a {
      color: $black;
      line-height: 1.5;
      font-size: 0.9em;
      text-decoration: none;

      @media #{$mobile} {
        font-size: 0.8em;
      }
    }
  }
}

.social {
  display: flex;
  flex-direction: row;
  margin: 30px 0 10px;

  @media #{mobile} {
    width: 30%;
    display: flex;
    justify-content: flex-end;
  }

  a {
    margin-right: 8px;
    width: 25px;

    img {
      width: 100%;
    }
  }

  @media #{$mobile} {
    margin: 0;

    a {
      margin-right: 10px;
    }

    img {
      width: 30px;
    }
  }
}

// Open State
.open {
  .navigation {

    @media #{$mobile} and (orientation: portrait) {
      transform: translateY(57px);
    }
  }
}
</style>
